import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import favicon from '../assets/images/favicon.png';
import orange_and_black_new from '../assets/images/orange-and-black-new.png';
import HeaderMenu from "./sidebar/headermenu";
import { API_STATUS } from "../constants";
import ClientDeclaration from "./client_declaration";
import TalentDeclaration from "./talent_declaration";
import { DeclarationApi } from "../apis/login/declaration_api";

export default function Declaration() {
    const { kyc, declaration } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const globalState = useSelector(state => state.globalstate);

    const [userApi, setUserApi] = useState(API_STATUS);
    const [accept, setAccept] = useState(false);
    const [validationError, setValidationError] = useState("");

    useEffect(() => {
        const token = sessionStorage.getItem('LOGIN_TOKEN');
        if (token == null) {
            navigate('/login');
        }
    }, [navigate]);

    const handleAcceptAndContinue = () => {
        if (!accept) {
            setValidationError("Please accept the declaration terms to proceed.");
            return;
        }

        setValidationError("");
        DeclarationApi({ declare: 1 }, setUserApi);
    };

    useEffect(() => {
        if (!userApi.isError && !userApi.isLoader && userApi.data != null) {
            if (userApi.data.status === 1) {
                navigate('/');
            }
            setValidationError("Network error try again.");
            return;
        }
    }, [userApi]);

    return (
        <div className="min-h-screen bg-slate-50 py-6">
            <main>
                <div>
                    <div className="main__inner max-w-4xl mx-auto px-4">

                        {/* Centered Logo Header */}
                        <div className="flex justify-center items-center h-20 px-2 max-md:fixed max-md:top-0 max-md:w-full max-md:bg-white/80 max-md:left-0 max-md:px-4 max-md:h-14 max-md:shadow-sm max-md:dark:bg-slate-900/80 backdrop-blur-xl z-10">
                            <a href="/" id="logo" className="flex items-center gap-3 justify-center">
                                <img
                                    id="logo__icon"
                                    src={favicon}
                                    alt="Logo Icon"
                                    className="md:w-8 hidden text-2xl max-xl:!block max-md:!hidden shrink-0 uk-animation-scale-up"
                                />
                                <img
                                    id="logo__text"
                                    src={orange_and_black_new}
                                    alt="Logo Text"
                                    className="h-12 w-auto object-contain dark:!hidden"
                                />
                                <img
                                    id="logo__text_dark"
                                    src={orange_and_black_new}
                                    alt="Logo Text Dark"
                                    className="h-12 w-auto object-contain !hidden dark:!block"
                                />
                            </a>
                        </div>

                        {/* Declarations Content Based on User Type */}
                        {sessionStorage.getItem('USER_TYPE') == 1 && (
                            <ClientDeclaration
                                accept={accept}
                                setAccept={(val) => {
                                    setAccept(val);
                                    if (val) setValidationError("");
                                }}
                            />
                        )}

                        {sessionStorage.getItem('USER_TYPE') == 0 && (
                            <TalentDeclaration
                                accept={accept}
                                setAccept={(val) => {
                                    setAccept(val);
                                    if (val) setValidationError("");
                                }}
                            />
                        )}

                        {/* Action Buttons & Validation - Rendered Directly After Content */}
                        <div className="">


                            <div className="flex items-center justify-center gap-4">


                                <button
                                    type="button"
                                    onClick={handleAcceptAndContinue}
                                    disabled={!accept}
                                    className={`px-8 py-2.5 rounded-full font-bold text-sm transition-all duration-200 ${accept
                                        ? "bg-blue-600 text-white hover:bg-blue-700 shadow-md hover:shadow-lg cursor-pointer"
                                        : "bg-slate-300 text-slate-500 cursor-not-allowed shadow-none opacity-60"
                                        }`}
                                >
                                    Accept & Continue →
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </main>
        </div>
    );
}